var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIotDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 60,
    viewBox: "0 0 105 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1201_10521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 39.9981V12.8003C0 5.75675 5.75675 0 12.8003 0H43.2998V27.1978C43.2998 34.2357 37.543 39.9981 30.4995 39.9981H0Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 4.79724C8.38659 4.79724 4.80273 8.38674 4.80273 12.7946V35.1951H30.4993C34.9071 35.1951 38.4966 31.6056 38.4966 27.1978V4.79724H12.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1006 30.0649H9.73584V17.3662H12.1006V30.0649V30.0649Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9977 25.6288C23.9977 29.0659 23.5406 30.1665 19.9398 30.1665C16.339 30.1665 15.8818 29.0659 15.8818 25.6288C15.8818 22.1917 16.339 21.0742 19.9398 21.0742C23.5406 21.0742 23.9977 22.1748 23.9977 25.6288ZM17.9531 25.6458C17.9531 28.0162 18.0999 28.5411 19.9398 28.5411C21.7797 28.5411 21.9264 28.0162 21.9264 25.6458C21.9264 23.2753 21.7797 22.6997 19.9398 22.6997C18.0999 22.6997 17.9531 23.2415 17.9531 25.6458V25.6458Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3912 30.0649H29.0264V19.4488H25.4087V17.3662H35.0033V19.4488H31.3912V30.0649V30.0649Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52189 49.113H1.61426V59.8928H3.52189V49.113Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2603 49.0001H10.5487C7.8396 49.0001 6.7334 50.191 6.7334 53.1032V55.8969C6.7334 58.8148 7.8396 60 10.5487 60H16.2603C18.9693 60 20.0755 58.8092 20.0755 55.8969V53.1032C20.0755 50.1853 18.9693 49.0001 16.2603 49.0001V49.0001ZM18.1679 52.584V56.4218C18.1679 57.7651 17.5753 58.3125 16.1248 58.3125H10.6898C9.23928 58.3125 8.64667 57.7651 8.64667 56.4218V52.584C8.64667 51.2407 9.23928 50.6933 10.6898 50.6933H16.1248C17.5753 50.6933 18.1679 51.2407 18.1679 52.584Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1748 50.8062H27.1866V59.8872H29.0885V50.8062H34.1003V49.113H22.1748V50.8062Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5163 57.4547L46.8724 49.113H44.3496V59.8872H46.2516V51.5173L51.8842 59.8872H53.1484L58.781 51.5173V59.8872H60.683V49.113H58.1602L52.5163 57.4547Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9486 55.1915H74.0137V53.4983H65.9486V50.8062H74.3411V49.113H64.041V59.8872H74.3975V58.194H65.9486V55.1915Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9629 53.5716H80.9896C78.8957 53.5716 78.8054 53.1596 78.8054 52.2284C78.8054 50.9077 79.257 50.6933 82.0281 50.6933H83.4504C86.8536 50.6933 86.8536 50.9134 86.8762 52.3356V52.6122H88.6992V51.9801C88.6992 49.8128 87.497 49.0057 84.2518 49.0057H81.3621C78.5797 49.0057 76.9712 49.5193 76.9712 52.1381C76.9712 55.2422 78.828 55.3833 82.6884 55.3833H85.2338C86.8705 55.3833 87.1132 55.6824 87.1132 56.7096C87.1132 57.9174 86.7915 58.3181 84.8783 58.3181H80.7131C78.9465 58.3181 78.8054 57.7763 78.8054 57.1216V56.1227H76.9825V57.1498C76.9825 60.0113 79.7593 60.0113 80.9501 60.0113H84.6751C86.2723 60.0113 88.9418 60.0113 88.9418 57.037V56.3766C88.9418 54.4464 87.7115 53.5829 84.9516 53.5829L84.9629 53.5716Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.431 49.113V53.4983H94.0385V49.113H92.1309V59.8872H94.0385V55.1915H102.431V59.8872H104.333V49.113H102.431Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1201_10521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.333,
    height: 60,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIotDesktop);
export default __webpack_public_path__ + "static/media/logo_iot_desktop.59e499507567cc300d08857f715dd000.svg";
export { ForwardRef as ReactComponent };